module.exports = __webpack_public_path__ + "static/detroit-7f7577b452c5908b40fdb7420f2b5ea3.png";